var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card"},[_c('v-icon',{staticClass:"pr-1",attrs:{"color":"white"}},[_vm._v("info")]),_c('div',{},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }